import { Navigate, Outlet, useParams, useLocation } from 'react-router-dom';
import { DEFAULT_LOCALE } from './constants';
import { isLocale, withLocale, stripLocale } from './paths';

/**
 * Validates /:locale/... for public auth routes.
 * Invalid locale → redirect to /en/...
 * Valid locale sync is handled by LocaleProvider from the URL.
 */
function PublicLocaleGate() {
  const { locale: localeParam } = useParams();
  const location = useLocation();

  if (!isLocale(localeParam)) {
    const rest = stripLocale(location.pathname);
    const target = rest === '/' ? '/login' : rest;
    return (
      <Navigate
        to={`${withLocale(DEFAULT_LOCALE, target)}${location.search}${location.hash}`}
        replace
      />
    );
  }

  return <Outlet />;
}

export default PublicLocaleGate;
